import { SpAlert } from '../../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(RegistrationProfile) {
        this.RegistrationProfile = RegistrationProfile;
    }

    $onInit() {
        this.profile = this.resolve.profile;
    }

    submit() {
        this.RegistrationProfile
            .delete({id: this.profile.id}).$promise
            .then(() => this.close())
            .catch((response) => {
                this.spAlert = new SpAlert('danger', response.data.message);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/delete/delete.controller.js